import { ContactType } from '@api/generated/graphql';
import { layoutLocators } from './layout';
import { AddressVerificationStatuses } from '@components/forms/components/AddressFormManager/components/AddressVerificationStatus/AddressVerificationDefinitions';

const customerSearch = {
  searchResults: 'Inbox-CustomerSearch-SearchResults',
  searchBtn: 'Inbox-CustomerSearch-Button',
  searchTitle: 'Inbox-CustomerSearch-Title',
  searchForm: {
    phone: 'Inbox-CustomerSearch-PhoneInput',
    name: 'Inbox-CustomerSearch-NameInput',
    street: 'Inbox-CustomerSearch-StreetInput',
    zip: 'Inbox-CustomerSearch-ZipInput',
  },
  contactMethods: {
    email: 'Inbox-CustomerSearch-EmailContactMethodsField',
    phone: 'Inbox-CustomerSearch-PhoneContactMethodsField',
  },
  newCustomerBtn: 'Inbox-CustomerSearch-NewCustomerBtn',
  taskrow: 'Inbox-TaskList-TaskRow',
  creteFormFields: {
    locationName: 'Inbox-CreateCustomer-LocationNameInput',
    searchForAnAddress: 'Inbox-CreateCustomer-SearchForAnAddressInput',
    enterAddressManually: 'Inbox-CreateCustomer-EnterAddressManuallyBtn',
    address: {
      street: 'Inbox-CreateCustomer-AddressStreetInput',
      unit: 'Inbox-CreateCustomer-AddressUnitInput',
      city: 'Inbox-CreateCustomer-AddressCityInput',
      state: 'Inbox-CreateCustomer-AddressStateInput',
      country: 'Inbox-CreateCustomer-AddressCountryInput',
      zip: 'Inbox-CreateCustomer-AddressZipInput',
      verifyAddressLabels: {
        [AddressVerificationStatuses.VERIFIED]: 'Inbox-CreateCustomer-Verified',
        [AddressVerificationStatuses.NO_RESULTS]:
          'Inbox-CreateCustomer-NoResults',
        [AddressVerificationStatuses.NOT_VERIFIED]:
          'Inbox-CreateCustomer-VerifyAddressBtn',
      },
    },
    addContactMethod: 'Inbox-CreateCustomer-AddContactMethodBtn',
    createsubmitBtn: 'Inbox-CreateCustomer-SubmitSaveBtn',
  },
  editFormFields: {
    [ContactType.Email]: 'Inbox-CustomerSearch-EditFormEmail',
    [ContactType.Fax]: 'Inbox-CustomerSearch-EditFormFax',
    [ContactType.MobilePhone]: 'Inbox-CustomerSearch-EditFormMobilePhone',
    [ContactType.Phone]: 'Inbox-CustomerSearch-EditFormPhone',
    [ContactType.Unknown]: 'Inbox-CustomerSearch-EditFormUnknown',
  },
  submitSaveBtn: 'Inbox-CustomerSearch-SubmitSaveBtn',
  editIconBtn: 'Inbox-CustomerSearch-EditIconBtn',
} as const;

const callBar = {
  callControls: 'Inbox-CallBar-CallControls',
  endCallButton: 'Inbox-CallBar-EndCallButton',
  toggleCallType: 'Inbox-CallBar-ToggleCallType',
  searchInputUser: 'Inbox-CallBar-SearchInputUser',
  usersListTableToCall: 'Inbox-CallBar-UsersListTableToCall',
  usersListRowSelectToCall: 'Inbox-CallBar-UsersListRowSelectToCall',
  tasksListTableCall: 'Inbox-CallBar-TasksListTableCall',
  tasksListRowSelectCall: 'Inbox-CallBar-TasksListRowSelectCall',
  displayNameChecker: 'Inbox-CallBar-DisplayNameChecker',
  muteBtnTooltip: 'Inbox-CallBar-MuteButtonTooltip',
  muteBtn: 'Inbox-CallBar-MuteButton',
  unmuteBtn: 'Inbox-CallBar-UnmuteButton',
  unmuteBtnTooltip: 'Inbox-CallBar-UnmuteButtonTooltip',
  placeCallOnHoldBtn: 'Inbox-CallBar-PlaceCallOnHoldBtn',
  placeCallOnHoldBtnTooltip: 'Inbox-CallBar-PlaceCallOnHoldBtnTooltip',
  resumeCallBtn: 'Inbox-CallBar-ResumeCallBtn',
  resumeCallBtnTooltip: 'Inbox-CallBar-ResumeCallBtnTooltip',
  pauseRecordingAudioCallBtn: 'Inbox-CallBar-PauseRecordingAudioCallBtn',
  pauseRecordingAudioCallTooltip:
    'Inbox-CallBar-PauseRecordingAudioCallTooltip',
} as const;

const taskList = {
  acceptButton: 'Inbox-TaskList-AcceptButton',
  closeButton: 'Inbox-TaskList-CloseButton',
  rejectButton: 'Inbox-TaskList-RejectButton',
  dismissButton: 'Inbox-TaskList-DismissButton',
  missedCallIcon: 'Inbox-TaskList-MissedCallIcon',
  taskTag: 'Inbox-TaskList-TaskTag',
  displayName: 'Inbox-TaskList-DisplayName',
  timeDisplay: 'Inbox-TaskList-TimeDisplay',
  tenantTag: 'Inbox-TaskList-TenantTag',
} as const;

const callClassificationModal = {
  modalContent: 'Inbox-CallClassification-Modal',
  goBackButton: 'Inbox-CallClassification-GoBackButton',
  closeAndClassifyButton: 'Inbox-CallClassification-CloseAndClassifyButton',
  reasonFormSelect: 'Inbox-CallClassification-ReasonFormSelect',
};

export const inboxLocators = {
  customerSearch,
  callBar,
  taskList,
  callClassificationModal,
  ...layoutLocators,
};
